module.exports = __webpack_public_path__ + "static/media/arthur.6e0c0c1f.jpg";